import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import TextField from "@material-ui/core/TextField";
import SweetAlert from "sweetalert2-react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import fire from "../config/Fire";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class AlertDialogSlide extends React.Component {
  constructor(props) {
    super(props);
    this.handleUploadAR = this.handleUploadAR.bind(this);
    this.cambiosInputs = this.cambiosInputs.bind(this);
  }
  state = {
    open: false,
    value: null,
    disabled: true,
    disabledu: true,
    link: "",
    contenido: "",
    titulo: "",
    imagen: null,
    uploadValue: 0,
    direccion: null,
    titulo1: ""
  };
  //Permite abrir el dialogo
  handleClickOpen = () => {
    this.setState({
      open: true
    });
  };
  //Permite cerrar el dialogo
  handleClose = () => {
    this.setState({
      open: false,
      value: null,
      disabled: true,
      disabledu: true,
      link: "",
      contenido: "",
      titulo: "",
      imagen: null,
      uploadValue: 0,
      direccion: null
    });
    this.setState({
      show: true,
      estado: "error",
      texto: "El post no ha sido creado",
      titulo1: "Error"
    });
  };
  //Permite saber si es imágen o video la que tendrá el post
  handleChange = event => {
    this.setState({ value: event.target.value });
    if (event.target.value === "imagen") {
      this.setState({ disabled: true, disabledu: false });
    } else this.setState({ disabled: false, disabledu: true });
  };
  //Guarda lo que escribe el usuario en los inputs
  cambiosInputs(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  //Crea el post
  subirPost = () => {
    var record = null;
    if (this.state.value === "imagen") {
      if (this.state.uploadValue === 100) {
        const key = new Date().getTime();
        record = {
          titulo: this.state.titulo,
          contenido: this.state.contenido,
          tipo: this.state.value,
          link: this.state.direccion,
          nombreimg: this.state.imagen.name
          //nombreimage: this.state.imagen.name,
        };
        fire
          .database()
          .ref()
          .child("Posts")
          .child(key)
          .set(record);

        this.satisfactorio();
      } else {
        this.setTimeout();
      }
    } else {
      const key = new Date().getTime();
      record = {
        titulo: this.state.titulo,
        contenido: this.state.contenido,
        tipo: this.state.value,
        link: this.state.link
      };
      fire
        .database()
        .ref()
        .child("Posts")
        .child(key)
        .set(record);
      this.satisfactorio();
    }
  };
  //Si es satisfactorio muestra el dialogo
  satisfactorio = () => {
    this.setState({
      open: false,
      value: null,
      disabled: true,
      disabledu: true,
      link: "",
      contenido: "",
      titulo: "",
      imagen: null,
      uploadValue: 0,
      direccion: null
    });
    this.setState({
      show: true,
      estado: "success",
      texto: "El post ha sido creado",
      titulo1: "¡Enhorabuena!"
    });
  };
  setTimeout = () => {
    setTimeout(this.subirPost, 2000);
  };
  //Permite saber el tipo de post
  handleNew = () => {
    var f = new Date();
    var fecha = f.getDate() + "-" + (f.getMonth() + 1) + "-" + f.getFullYear();
    var tit = this.state.titulo + " " + fecha;

    if (this.state.value !== null && this.state.titulo !== "") {
      if (this.state.contenido.length < 150) {
        if (this.state.value === "imagen") {
          if (this.state.imagen !== null) {
            this.setState({ titulo: tit });
            this.subirImagen(tit);
            this.subirPost();
          } else {
            alert("Debe existir una imagen en el post");
          }
        }
        if (this.state.value === "video") {
          if (this.state.link !== "") {
            this.setState({ titulo: tit });
            setTimeout(this.subirPost, 10);
          } else {
            alert("Debe existir un link en el post");
          }
        }
      } else alert("El detalle del post debe ser menor a 150 caracteres");
    } else {
      alert("Debe existir contenido en el post");
    }
  };
  //Sube la imagen a firebase
  subirImagen(titulo) {
    if (this.state.imagen !== null) {
      const storageRef = fire
        .storage()
        .ref(`/Posts/${titulo}/${this.state.imagen.name}`);
      const task = storageRef.put(this.state.imagen);
      task.on(
        "state_changed",
        snapshot => {
          let percentage =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.setState({
            uploadValue: percentage
          });
        },
        error => {},
        () => {
          storageRef.getDownloadURL().then(url => {
            this.setState({
              direccion: url
            });
          });
        }
      );
    }
  }
  //Guarda información de la imagen
  handleUploadAR(event) {
    const file = event.target.files[0];
    this.setState({ imagen: file });
  }
  //Renderiza la interfaz del diálogo
  render() {
    return (
      <div>
        <div>
          <Button
            variant="outlined"
            color="primary"
            onClick={this.handleClickOpen}
          >
            Nuevo post VIP
          </Button>
          <Dialog
            open={this.state.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Nuevo post VIP"}
            </DialogTitle>
            <DialogContent>
              <TextField
                id="outlined-full-width"
                label="Título"
                fullWidth
                margin="normal"
                variant="outlined"
                name="titulo"
                onChange={this.cambiosInputs}
                value={this.state.titulo}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="outlined-full-width"
                label="Detalle"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                name="contenido"
                onChange={this.cambiosInputs}
                value={this.state.contenido}
              />
              <FormControl component="fieldset">
                <FormLabel component="legend">Contenido</FormLabel>
                <RadioGroup
                  aria-label="Gender"
                  name="gender1"
                  value={this.state.value}
                  onChange={this.handleChange}
                >
                  <FormControlLabel
                    value="imagen"
                    control={<Radio />}
                    label="Imagen"
                  />
                  <FormControlLabel
                    value="video"
                    control={<Radio />}
                    label="Video"
                  />
                </RadioGroup>
              </FormControl>

              <TextField
                disabled={this.state.disabled}
                id="outlined-full-width"
                label="Link"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                name="link"
                onChange={this.cambiosInputs}
                value={this.state.link}
              />
              <div>
                <br />
                <input
                  accept="image/*"
                  type="file"
                  disableUnderline={true}
                  disabled={this.state.disabledu}
                  name="Imagen"
                  onChange={this.handleUploadAR}
                />
                <br />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Cancelar
              </Button>
              <Button onClick={this.handleNew} color="primary">
                Crear post
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <SweetAlert
            show={this.state.show}
            title={this.state.titulo1}
            type={this.state.estado}
            text={this.state.texto}
            onConfirm={() => this.setState({ show: false })}
          />
        </div>
      </div>
    );
  }
}

export default AlertDialogSlide;
